/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'SalesFilterEventType'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('salesfiltereventtype'); // main translation loaded for salesfiltereventtype
		$translatePartialLoader.addPart('salesfilter'); // one to many reference from main entity
		$translatePartialLoader.addPart('eventtype'); // one to many reference from main entity
		$translatePartialLoader.addPart('salesfilter'); // coupling entity reference loaded for salesfilter
		$translatePartialLoader.addPart('eventtype'); // coupling entity reference loaded for eventtype

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/salesfiltereventtype/salesfiltereventtype-dialog.html';

		return {
			/* new state for entity salesFilterEventType */
			/* to access: ui-ref="salesfiltereventtype.list.new" */
			/* url: hostname/salesfiltereventtype/new */
			url: url,
			data: {
				authorities: [],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'SalesFilterEventTypeDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'SalesFilterEventTypeFactory',
									'NewSalesFilterEventTypeFactory',
									function(SalesFilterEventTypeFactory, NewSalesFilterEventTypeFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new SalesFilterEventType
										// - resuming the creation of a new new SalesFilterEventType AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return SalesFilterEventTypeFactory.get({ id: $stateParams.salesFilterEventTypeId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewSalesFilterEventTypeFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for salesFilterEventType new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for salesFilterEventType edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('salesfiltereventtype', {
		/* abstract state for entity salesFilterEventType */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/salesfiltereventtype',
		data: {
			authorities: [],
			pageTitle: 'SalesFilterEventTypes',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('salesfiltereventtype.list', {
		/* list state for entity salesFilterEventType */
		/* to access: ui-ref="salesfiltereventtype.list" */
		/* url: hostname/salesfiltereventtype/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfiltereventtype/salesfiltereventtypes.html',
				controller: 'SalesFilterEventTypeController',
			},
		},
	});

	$stateProvider.state('salesfiltereventtype.detail', {
		/* detail state for entity salesFilterEventType */
		/* to access: ui-sref="salesfiltereventtype.detail" */
		/* url: hostname/salesfiltereventtype/detail/:salesFilterEventTypeId */
		url: '/detail/:salesFilterEventTypeId',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfiltereventtype/salesfiltereventtype-detail.html',
				controller: 'SalesFilterEventTypeDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'SalesFilterEventTypeFactory',
				function($stateParams, SalesFilterEventTypeFactory) {
					return SalesFilterEventTypeFactory.get({ id: $stateParams.salesFilterEventTypeId });
				},
			],
		},
	});

	$stateProvider.state('user-salesfiltereventtype', {
		/* abstract state for DTO UserSalesFilterEventTypeListDto */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/user/salesfiltereventtype',
		data: {
			authorities: ['ROLE_USER', 'ROLE_ADMIN'],
			pageTitle: 'SalesFilterEventType',
			isModal: false,
		},
		params: {
			mappedBy: null,
			mappedByType: null,
			mappedById: null,
			dataModel: null, // this data model is set from the new relation state OR from the save and new logic
			mappedByDisplayValue: null,
			dataModelType: null, // this data model type is the name of the modelobject, lowercase

			hiddenParam: 'YES', // hides params from url
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	/* list state for DTO user */
	var dtoListState = {
		/* list state for DTO UserSalesFilterEventTypeListDto */
		/* to access: ui-ref="user-salesfiltereventtype.list" */
		/* url: http://<hostname>/user/salesfiltereventtype/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfiltereventtype/salesfiltereventtype-list-user.html',
				controller: 'UserSalesFilterEventTypeListDtoController',
			},
		},
	};

	$stateProvider.state('user-salesfiltereventtype.list', dtoListState);
});
